/* globals __VERSION__ __MODULE_NAME__, __API_BASE_URL__ */
export const API_BASE_URL = __API_BASE_URL__;
export const VERSION = __VERSION__;
export const MODULE_NAME = __MODULE_NAME__;
